import { gql } from '@apollo/client'

export const GET_EXTENDED_PLAYER_INFO = gql`
  query GetExtendedPlayerInfo($playerId: ID!, $seasonCode: String) {
    getExtendedPlayerInfo(playerId: $playerId, seasonCode: $seasonCode) {
      player {
        id
        nick
        name
        lastName
        role
        image
        marketValue
        previousMarketValue
        team {
          id
          competition {
            id
            code
            displayName
            rank
          }
          fullName
          shortName
          nameShow
          shield
          createdAt
        }
      }
      nextMatch {
        id
        matchDate
        status
        matchWeek {
          id
          weekNumber
        }
        homeTeam {
          id
          nameShow
          shield
        }
        awayTeam {
          id
          nameShow
          shield
        }
      }
      marketValueHistory {
        marketValue
        validUntil
      }
      allSeasons {
        id
        code
        displayName
        active
      }
      matchPlayersPerSeasonCompetition {
        seasonCompetition {
          id
          competition {
            id
            displayName
            code
          }
        }
        teamPointsPerMatch
        lastFiveAverage
        onPitchPointsPerMatch
        starterPointsPerMatch
        matchPlayers {
          id
          minutesPlayed
          goals
          penaltyGoals
          yellowCards
          redCard
          teamGoals
          rivalGoals
          fantasyScore
          match {
            id
            goalsHome
            goalsAway
            matchDate
            matchWeek {
              id
              weekNumber
            }
            homeTeam {
              id
              shortName
            }
            awayTeam {
              id
              shortName
            }
          }
        }
      }
    }
  }
`
